import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import type { TTransferPricingPolicyHistoryResponse } from './types';

/** Every recorded change to the policy's fields, newest first. */
export function usePolicyHistory(policyId: string | null | undefined) {
  const { data, error, isLoading, mutate } =
    useSWR<TTransferPricingPolicyHistoryResponse>(
      policyId
        ? `transfer-pricing/policy/${encodeURIComponent(policyId)}/history`
        : null,
      SWRFetcher({ method: 'GET' })
    );

  return {
    changes: data?.changes,
    error,
    isLoading,
    mutate,
  };
}
